import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SysConfigService } from './sys-config.service';
import {OperationPrivilageModel} from '../dto/operation-privilage-model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class OperationPrivilageService {
  private BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  constructor(private http: HttpClient, private appConfig: AppConfig) { }

  public addOperationPrivilage(dto: OperationPrivilageModel): Observable<boolean> {
    return this.http.post<boolean>(this.BASE_URL + 'operation-privilage/save', dto);
  }

  public getByUser(userName: string): Observable<OperationPrivilageModel[]> {
    return this.http.get<OperationPrivilageModel[]>(this.BASE_URL + 'operation-privilage/get/' + userName);
  }

  /** Get All Operation Privielges **/
  getAllOperationPrivileges() {
    return this.http.get(this.BASE_URL + 'operation-privilage/all');
  }
}
